import React from "react";
import "/src/assets/scss/components/heros.scss";

function HeroAbout() {
  return (
    <div className="hero hero-about">
      <h1 className="title-1">FANTASTIC FISH COMPANY</h1>
    </div>
  );
}

export default HeroAbout;
